var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"editForm",attrs:{"size":"small","label-position":"top","model":_vm.scale,"rules":_vm.rules}})}
var staticRenderFns = []

export { render, staticRenderFns }